import { trackMemoryUsage } from '@/common/utils/telemetry/useTelemetry';

export interface MemoryInfo {
  usedJSHeapSize?: number;
  totalJSHeapSize?: number;
  jsHeapSizeLimit?: number;
  timestamp: number;
}

export interface PerformanceMemory {
  usedJSHeapSize: number;
  totalJSHeapSize: number;
  jsHeapSizeLimit: number;
}

declare global {
  interface Performance {
    memory?: PerformanceMemory;
  }
}

const getMemoryInfo = (): MemoryInfo | null => {
  try {
    if (!performance.memory) {
      return null;
    }

    const memoryInfo: MemoryInfo = {
      usedJSHeapSize: performance.memory.usedJSHeapSize,
      totalJSHeapSize: performance.memory.totalJSHeapSize,
      jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
      timestamp: Date.now()
    };

    return memoryInfo;
  } catch (error) {
    return null;
  }
};

export const trackMemorySnapshot = (additionalProperties?: Record<string, unknown>): void => {
  try {
    const memoryInfo = getMemoryInfo();

    if (!memoryInfo) {
      return;
    }

    trackMemoryUsage(memoryInfo, additionalProperties);
  } catch (error) {
    // Silently fail memory tracking to avoid affecting app performance
  }
};
